import React from 'react';
import { Link, Typography, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const InfoTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 400,
      // fontSize: theme.typography.pxToRem(12),
      fontSize: 16,
      border: '1px solid #dadde9',
    },
  }))(Tooltip);
  export default InfoTooltip;